/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import AqaAnnotationScore from '../model/AqaAnnotationScore';
import AqaBulkRowStatiRequest from '../model/AqaBulkRowStatiRequest';
import AqaCellNote from '../model/AqaCellNote';
import AqaCellStatusResponse from '../model/AqaCellStatusResponse';
import AqaNoteResponse from '../model/AqaNoteResponse';
import AqaResponse from '../model/AqaResponse';
import AqaRowCellNoteBlock from '../model/AqaRowCellNoteBlock';
import AqaRowStatusStatistics from '../model/AqaRowStatusStatistics';

/**
* AQAReviewController service.
* @module api/AQAReviewControllerApi
* @version v0
*/
export default class AQAReviewControllerApi {

    /**
    * Constructs a new AQAReviewControllerApi. 
    * @alias module:api/AQAReviewControllerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the closeStatusEditingOnSnapshot operation.
     * @callback moduleapi/AQAReviewControllerApi~closeStatusEditingOnSnapshotCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Closes a snapshot stati editing window
     * @param {String} snapshotId 
     * @param {module:api/AQAReviewControllerApi~closeStatusEditingOnSnapshotCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    closeStatusEditingOnSnapshot(snapshotId, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling closeStatusEditingOnSnapshot");
      }

      let pathParams = {
        'snapshotId': snapshotId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/review/snapshots/{snapshotId}/close', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getAnnotationsScore operation.
     * @callback moduleapi/AQAReviewControllerApi~getAnnotationsScoreCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaAnnotationScore{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a Snapshot&#x27;s cell override stati as a bitmap
     * @param {String} snapshotId 
     * @param {String} orientation 
     * @param {module:api/AQAReviewControllerApi~getAnnotationsScoreCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAnnotationsScore(snapshotId, orientation, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getAnnotationsScore");
      }
      // verify the required parameter 'orientation' is set
      if (orientation === undefined || orientation === null) {
        throw new Error("Missing the required parameter 'orientation' when calling getAnnotationsScore");
      }

      let pathParams = {
        'snapshotId': snapshotId,'orientation': orientation
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = AqaAnnotationScore;

      return this.apiClient.callApi(
        '/api/v1/review/snapshots/{snapshotId}/{orientation}/annotationscore', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getCellOverrideStati operation.
     * @callback moduleapi/AQAReviewControllerApi~getCellOverrideStatiCallback
     * @param {String} error Error message, if any.
     * @param {'Blob'{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a Snapshot&#x27;s cell override stati as a bitmap
     * @param {String} snapshotId 
     * @param {String} orientation 
     * @param {module:api/AQAReviewControllerApi~getCellOverrideStatiCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getCellOverrideStati(snapshotId, orientation, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getCellOverrideStati");
      }
      // verify the required parameter 'orientation' is set
      if (orientation === undefined || orientation === null) {
        throw new Error("Missing the required parameter 'orientation' when calling getCellOverrideStati");
      }

      let pathParams = {
        'snapshotId': snapshotId,'orientation': orientation
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = 'Blob';

      return this.apiClient.callApi(
        '/api/v1/review/snapshots/{snapshotId}/{orientation}/stati/cells', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getNotes operation.
     * @callback moduleapi/AQAReviewControllerApi~getNotesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaRowCellNoteBlock{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a list of Cell notes whose index got from from to to - 1
     * @param {String} snapshotId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.from  (default to <.>)
     * @param {Number} opts.to  (default to <.>)
     * @param {module:api/AQAReviewControllerApi~getNotesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getNotes(snapshotId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling getNotes");
      }

      let pathParams = {
        'snapshotId': snapshotId
      };
      let queryParams = {
        'from': opts['from'],'to': opts['to']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaRowCellNoteBlock;

      return this.apiClient.callApi(
        '/api/v1/review/snapshots/{snapshotId}/notes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the retrieveStati operation.
     * @callback moduleapi/AQAReviewControllerApi~retrieveStatiCallback
     * @param {String} error Error message, if any.
     * @param {'Blob'{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a Snapshot&#x27;s stati - you must specify the unfiltered table id
     * @param {String} snapshotId 
     * @param {String} orientation 
     * @param {module:api/AQAReviewControllerApi~retrieveStatiCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    retrieveStati(snapshotId, orientation, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling retrieveStati");
      }
      // verify the required parameter 'orientation' is set
      if (orientation === undefined || orientation === null) {
        throw new Error("Missing the required parameter 'orientation' when calling retrieveStati");
      }

      let pathParams = {
        'snapshotId': snapshotId,'orientation': orientation
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = 'Blob';

      return this.apiClient.callApi(
        '/api/v1/review/snapshots/{snapshotId}/{orientation}/stati', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the retrieveStatiStatistics operation.
     * @callback moduleapi/AQAReviewControllerApi~retrieveStatiStatisticsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaRowStatusStatistics{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a Snapshot&#x27;s stati statistics - you must specify the unfiltered table id
     * @param {String} snapshotId 
     * @param {String} orientation 
     * @param {module:api/AQAReviewControllerApi~retrieveStatiStatisticsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    retrieveStatiStatistics(snapshotId, orientation, callback) {
      
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling retrieveStatiStatistics");
      }
      // verify the required parameter 'orientation' is set
      if (orientation === undefined || orientation === null) {
        throw new Error("Missing the required parameter 'orientation' when calling retrieveStatiStatistics");
      }

      let pathParams = {
        'snapshotId': snapshotId,'orientation': orientation
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaRowStatusStatistics;

      return this.apiClient.callApi(
        '/api/v1/review/snapshots/{snapshotId}/{orientation}/stati/statistics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the saveCellNote operation.
     * @callback moduleapi/AQAReviewControllerApi~saveCellNoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaNoteResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Saves a combo cell suggested value / note
     * @param {module:model/AqaCellNote} body 
     * @param {module:api/AQAReviewControllerApi~saveCellNoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    saveCellNote(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling saveCellNote");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaNoteResponse;

      return this.apiClient.callApi(
        '/api/v1/review/snapshots/notes', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateCellStatus operation.
     * @callback moduleapi/AQAReviewControllerApi~updateCellStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaCellStatusResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates a cell&#x27;s status - you must specify the unfiltered table id
     * @param {String} snapshotId 
     * @param {String} orientation 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.position  (default to <.>)
     * @param {Number} opts.index  (default to <.>)
     * @param {Blob} opts.value  (default to <.>)
     * @param {module:api/AQAReviewControllerApi~updateCellStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateCellStatus(snapshotId, orientation, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling updateCellStatus");
      }
      // verify the required parameter 'orientation' is set
      if (orientation === undefined || orientation === null) {
        throw new Error("Missing the required parameter 'orientation' when calling updateCellStatus");
      }

      let pathParams = {
        'snapshotId': snapshotId,'orientation': orientation
      };
      let queryParams = {
        'position': opts['position'],'index': opts['index'],'value': opts['value']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaCellStatusResponse;

      return this.apiClient.callApi(
        '/api/v1/review/snapshots/{snapshotId}/{orientation}/stati/cell', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateCellStatusInBulk operation.
     * @callback moduleapi/AQAReviewControllerApi~updateCellStatusInBulkCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaCellStatusResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates cell stati in bulk - you must specify the unfiltered table id
     * @param {module:model/AqaBulkRowStatiRequest} body 
     * @param {String} snapshotId 
     * @param {String} orientation 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.index  (default to <.>)
     * @param {module:api/AQAReviewControllerApi~updateCellStatusInBulkCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateCellStatusInBulk(body, snapshotId, orientation, opts, callback) {
      opts = opts || {};
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateCellStatusInBulk");
      }
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling updateCellStatusInBulk");
      }
      // verify the required parameter 'orientation' is set
      if (orientation === undefined || orientation === null) {
        throw new Error("Missing the required parameter 'orientation' when calling updateCellStatusInBulk");
      }

      let pathParams = {
        'snapshotId': snapshotId,'orientation': orientation
      };
      let queryParams = {
        'index': opts['index']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaCellStatusResponse;

      return this.apiClient.callApi(
        '/api/v1/review/snapshots/{snapshotId}/{orientation}/stati/cell/bulk', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateStatus operation.
     * @callback moduleapi/AQAReviewControllerApi~updateStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates a vector status - you must specify the unfiltered table id
     * @param {String} snapshotId 
     * @param {String} orientation 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.position  (default to <.>)
     * @param {Blob} opts.value  (default to <.>)
     * @param {module:api/AQAReviewControllerApi~updateStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateStatus(snapshotId, orientation, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling updateStatus");
      }
      // verify the required parameter 'orientation' is set
      if (orientation === undefined || orientation === null) {
        throw new Error("Missing the required parameter 'orientation' when calling updateStatus");
      }

      let pathParams = {
        'snapshotId': snapshotId,'orientation': orientation
      };
      let queryParams = {
        'position': opts['position'],'value': opts['value']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/review/snapshots/{snapshotId}/{orientation}/stati', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateStatusInBulk operation.
     * @callback moduleapi/AQAReviewControllerApi~updateStatusInBulkCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates a vector multiple stati - you must specify the unfiltered table id
     * @param {module:model/AqaBulkRowStatiRequest} body 
     * @param {String} snapshotId 
     * @param {String} orientation 
     * @param {module:api/AQAReviewControllerApi~updateStatusInBulkCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateStatusInBulk(body, snapshotId, orientation, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateStatusInBulk");
      }
      // verify the required parameter 'snapshotId' is set
      if (snapshotId === undefined || snapshotId === null) {
        throw new Error("Missing the required parameter 'snapshotId' when calling updateStatusInBulk");
      }
      // verify the required parameter 'orientation' is set
      if (orientation === undefined || orientation === null) {
        throw new Error("Missing the required parameter 'orientation' when calling updateStatusInBulk");
      }

      let pathParams = {
        'snapshotId': snapshotId,'orientation': orientation
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/review/snapshots/{snapshotId}/{orientation}/stati/bulk', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}